
export class LayoutTranslationConfig {
  public layoutTranslations = {
    'en': {
      help: 'Help',
      mom: 'MOM',
      mtd: 'MTD',
      yoy: 'YOY',
      language: 'Language',
      logout: 'Log Out',
      support: 'Support',
      close: 'Close',
      english: 'English',
      french: 'French',
      apply: 'Apply',
      website: 'Website',
      digitaladvertising: 'Digital Advertising',
      // report navigation
      overview: 'Overview',
      scorecard: 'Scorecard',
      summary: 'Summary',
      referrer: 'Referrer',
      vehicle: 'Vehicle',
      supplier: 'Supplier',
      provider: "Provider",
      channel: "Channel",
      supplierscorecard: 'Supplier Scorecard',
      websitesupplierscorecard: 'Website Supplier Scorecard',
      management: 'Management',
      content: 'Content',
      users: 'Users',
      // report titles
      // Website
      websiteoverview: 'Website Overview',
      websitesummary: 'Website Summary',
      referrersummary: 'Referrer Report',
      referrerreport: 'Referrer Report',
      vehiclesummary: 'Vehicle Summary',
      websiteproviderperformance: 'Website Provider Performance',
      websitesupplierperformance: 'Website Supplier Performance',
      providersummary: 'Website Supplier Performance',
      providerscorecard: 'Website Supplier Scorecard',
      // DigAd
      digitaladvertisingoverview: 'Digital Advertising Overview',
      digitaladvertisingscorecard: 'Digital Advertising Scorecard',
      digitaladvertisingsummary: 'Digital Advertising Summary',
      digitaladvertisingchannelperformance: "Digital Advertising Channel Performance",
      digitaladvertisingproviderperformance: "Digital Advertising Provider Performance",
      //
      yourlanguageselectionwillbeappliedthroughouttheapplication: 'Votre sélection de langue sera appliquée tout au long de l\'application.'
    },
    'fr-CA' : {
      help: 'Aide',
      mom: 'MSM',
      mtd: 'MÀJ',
      yoy: 'ASA',
      language: 'La Langue',
      logout: 'Se Déconnecter',
      support: 'Soutien',
      close: 'Fermer',
      english: 'Anglaise',
      french: 'Français',
      apply: 'Appliquer',
      website: 'Web',
      digitaladvertising: 'Publicité Numérique',
      // report navigation
      overview: 'Aperçu',
      scorecard: 'Tableau de bord',
      summary: 'Sommaire',
      referrer: 'Référent',
      vehicle: 'Véhicule',
      supplier: 'Fournisseur',
      provider: "Fournisseur",
      channel: "Chaîne",
      supplierscorecard: 'Tableau de bord du fournisseur',
      management: 'Utilisateurs',
      content: 'Content',
      users: 'Utilisateurs',
      sales: 'Ventes',
      // report titles
      websiteoverview: 'Aperçu du site Web',
      websitescorecard: 'Tableau de bord',
      websitesummary: 'Sommaire de site Web',
      referrersummary: 'Référent',
      referrerreport: 'Référent',
      vehiclesummary: 'Résumé du véhicule',
      suppliersummary: 'Performance du fournisseur de site Web',
      websiteproviderperformance: 'Performance du fournisseur de site Web',
      websitesupplierperformance: 'Performance du fournisseur de site Web',
      websitesuppliersummary: 'Performance du fournisseur de site Web',
      websitesupplierscorecard:  'Tableau de bord du fournisseur',
      providerscorecardreport: 'Tableau de bord du fournisseur',
      usermanagement: 'Gestion des utilisateurs',
      salesoverview: 'Aperçu des ventes',
      salessourceperformance: 'Performance de la source de vente',
      salessummary: 'Résumé des ventes',
      vehicleperformance: 'Performance du véhicule',
      // DigAd
      digitaladvertisingoverview: 'Présentation Stratégie Numérique',
      digitaladvertisingscorecard: 'Tableau de Bord Stratégie Numérique',
      digitaladvertisingsummary: 'Sommaire Stratégie Numérique',
      digitaladvertisingchannelperformance: 'Performance du canal publicitaire numérique',
      digitaladvertisingproviderperformance: 'Performance du fournisseur de publicité numérique',
      yourlanguageselectionwillbeappliedthroughouttheapplication: 'Votre sélection de langue sera appliquée tout au long de l\'application.'
    }
  };

  public navLabelTranslations = {
    'en': {
      website: 'Website',
      overview: 'Overview',
      scorecard: 'Scorecard',
      summary: 'Summary',
      referrer: 'Referrer',
      vehicle: 'Vehicle',
      supplier: 'Supplier',
      supplierscorecard: 'Supplier Scorecard',
      management: 'Management',
      content: 'Content',
      users: 'Users',
    },
    'fr-CA': {
      website: 'Web',
      overview: 'Aperçu',
      scorecard: 'Tableau de bord',
      summary: 'Sommaire',
      referrer: 'Référent',
      vehicle: 'Véhicule',
      supplier: 'Fournisseur',
      supplierscorecard: 'Tableau de bord du fournisseur',
      management: 'Utilisateurs',
      content: 'Content',
      users: 'Utilisateurs',
    }

  };
}

